import React from 'react'
import styled from 'styled-components'
import media from '../../../styles/media'

const Tag = styled.p`
  margin: 0;
  font-size: 10px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #fbf6f3;
  ${media.md`
    font-size: 15px;
  `};
`

const TagWrapper = styled.div`
  display: flex;
  align-items: center;
  ${media.md`
    margin-left: 25px;  
  `};
`

function InfoTag({ message }) {
  return (
    <TagWrapper>
      <Tag>{message}</Tag>
    </TagWrapper>
  )
}

export default InfoTag



// WEBPACK FOOTER //
// ./src/components/step/infotag/infotag.js